const UTILS = require("../libs/utils.js");
const config = require("../config.js");
module.exports = [{
  name: "Default",
  dir: function (p4911, p4912, p4913, p4914, p4915) {
    var v4349 = p4911.config.trnSp || 1;
    v4349 *= p4911.config.trnSpd || 1;
    var v4350 = p4912.round(3);
    var v4351 = p4913.round(3);
    if (v4349 >= 1) {
      p4911.xDire = v4350;
      p4911.yDire = v4351;
      if (p4911.yDire > Math.PI / 2) {
        p4911.yDire = Math.PI / 2;
      } else if (p4911.yDire < -(Math.PI / 2)) {
        p4911.yDire = -(Math.PI / 2);
      }
    } else {
      var v4352 = Math.PI * 2;
      var v4353 = v4349 * 0.01 * p4915;
      var v4354 = (p4911.xDire - v4350 + v4352) % v4352;
      var v4355 = Math.min(Math.abs(v4354 - v4352), v4354, v4353);
      var v4356 = v4354 - Math.PI >= 0 ? 1 : -1;
      p4911.xDire += v4356 * v4355 + v4352;
      p4911.xDire %= v4352;
      if (p4911.yDire < v4351) {
        p4911.yDire += v4353;
        if (p4911.yDire > v4351) {
          p4911.yDire = v4351;
        }
      } else if (p4911.yDire > v4351) {
        p4911.yDire -= v4353;
        if (p4911.yDire < v4351) {
          p4911.yDire = v4351;
        }
      }
    }
  },
  mov: function (p4916, p4917, p4918, p4919, p4920, p4921, p4922) {
    var v4357 = p4916.xDire;
    if (p4916.config.camType == 1 && !p4916.config.camRot) {
      v4357 = -UTILS.getDir(p4916.config.camOffX, p4916.config.camOffZ, 0, 0);
      v4357 %= Math.PI;
    }
    if (p4919 != Math.PI && p4919 != 0 && p4919 != Math.PI / 2 && p4919 != -Math.PI / 2) {
      p4917 *= p4922.config && !p4922.mode.realMov ? p4922.config.strafeSpd : 1;
    }
    if (p4919 !== undefined) {
      p4916.velocity.x += p4917 * Math.cos(p4919 - v4357);
      p4916.velocity.z += p4917 * Math.sin(p4919 - v4357);
      if (p4916.noclip) {
        p4916.velocity.y += p4917 * (p4916.yDire * (p4919 > 0 ? -1 : 1));
      }
    }
  },
  vel: function (p4923, p4924, p4925, p4926) {
    if (p4926.config.fixMov && !p4923.noclip) {
      if (p4923.velocity.x) {
        var v4360 = p4923.velocity.x * Math.pow(p4924, p4925);
        p4923.x += (v4360 - p4923.velocity.x) / Math.log(p4924) * p4923.config.speedX;
        p4923.velocity.x = v4360;
        p4923.velocity.x = UTILS.cropVal(p4923.velocity.x, config.decelMin);
      }
      if (p4923.velocity.y) {
        var vLN09993 = 0.9993;
        var v4360 = p4923.velocity.y * Math.pow(vLN09993, p4925);
        p4923.y += (v4360 - p4923.velocity.y) / Math.log(vLN09993) * p4923.config.speedY;
        p4923.velocity.y = v4360;
      }
      if (p4923.velocity.z) {
        var v4360 = p4923.velocity.z * Math.pow(p4924, p4925);
        p4923.z += (v4360 - p4923.velocity.z) / Math.log(p4924) * p4923.config.speedZ;
        p4923.velocity.z = v4360;
        p4923.velocity.z = UTILS.cropVal(p4923.velocity.z, config.decelMin);
      }
    } else {
      if (p4923.velocity.x) {
        p4923.x += p4923.velocity.x * p4923.config.speedX * p4925;
        p4923.velocity.x *= Math.pow(p4924, p4925);
        p4923.velocity.x = UTILS.cropVal(p4923.velocity.x, config.decelMin);
      }
      if (p4923.velocity.y) {
        p4923.y += p4923.velocity.y * p4923.config.speedY * p4925;
        if (p4923.noclip) {
          p4923.velocity.y *= Math.pow(p4924, p4925);
        } else if (p4923.velocity.y > 0) {
          p4923.velocity.y -= p4925 * 0.000032;
        } else if (p4923.velocity.y <= -0.3) {
          p4923.velocity.y = -0.3;
        }
      }
      if (p4923.velocity.z) {
        p4923.z += p4923.velocity.z * p4923.config.speedZ * p4925;
        p4923.velocity.z *= Math.pow(p4924, p4925);
        p4923.velocity.z = UTILS.cropVal(p4923.velocity.z, config.decelMin);
      }
    }
  }
}, {
  name: "Follow Mouse",
  mov: function (p4927, p4928) {
    var v4361 = -p4927.xDire - Math.PI / 2;
    p4927.velocity.x += p4928 * Math.cos(v4361);
    p4927.velocity.z += p4928 * Math.sin(v4361);
  }
}, {
  name: "Move Right",
  mov: function (p4929) {
    p4929.velocity.x = 0.01;
    p4929.velocity.z = 0;
  }
}, {
  name: "Fly",
  mov: function (p4930, p4931) {
    var v4362 = p4930.xDire + Math.PI;
    var v4363 = p4930.yDire;
    p4930.velocity.x += p4931 * Math.sin(v4362) * Math.cos(v4363);
    p4930.velocity.z += p4931 * Math.cos(v4362) * Math.cos(v4363);
    p4930.velocity.y += p4931 * Math.sin(v4363);
  }
}, {
  name: "Dir Only",
  mov: function (p4932, p4933, p4934, p4935) {
    if (p4935 !== undefined) {
      p4932.velocity.x += p4933 * Math.cos(p4935);
      p4932.velocity.z += p4933 * Math.sin(p4935);
    }
  }
}, {
  name: "SRM",
  airDecel: 1,
  noThrow: true,
  noWallJ: true,
  sendVals: ["onGroundFrames", "onWallFrames", "wishDash", "dashTimer", "walldashTimer", "tmpVel"],
  config: {
    friction: 0.006,
    baseSpeed: 0.07,
    groundAcceleration: 0.014,
    groundDeacceleration: 0.01,
    airAcceleration: 0.00085,
    airDeacceleration: 0.00085,
    sideStrafeAcceleration: 0.05,
    sideStrafeSpeed: 0.01,
    minRampSlideVelocity: 0.125,
    onWallMaxFrames: 116,
    dash: {
      acceleration: 1000,
      cooldown: 1000,
      speed: 0.09999500000000001,
      height: 0.035
    },
    walldash: {
      acceleration: 1000,
      cooldown: 1150,
      speed: 0.052500000000000005,
      height: 0.07
    },
    wallNormal: [{
      x: 1,
      y: 0,
      z: 0
    }, {
      x: -1,
      y: 0,
      z: 0
    }, {
      x: 0,
      y: 0,
      z: 1
    }, {
      x: 0,
      y: 0,
      z: -1
    }],
    nDir: {
      [0]: "x",
      [Math.PI / 2]: "z",
      [Math.PI]: "x",
      [Math.PI * 1.5]: "z"
    }
  },
  mov: function (p4936, p4937, p4938, p4939, p4940, p4941, p4942, p4943) {
    if (p4936.onGround) {
      p4936.onGroundFrames += p4943;
    } else {
      p4936.onGroundFrames = 0;
    }
    if (p4936.onWall) {
      p4936.onWallFrames += p4943;
    } else {
      p4936.onWallFrames = 0;
    }
    p4936.wishJump = false;
    p4936.collidingRamp = null;
    if (p4936.onGround) {
      var v4364 = p4942.map.manager.getGridArrays(p4936.x, p4936.y, p4936.z);
      if (v4364) {
        p4936.collidingRamp = v4364.find(function (p4944) {
          if (p4944.ramp) {
            return p4936.collides(p4944);
          }
        }) || null;
      }
    }
    if (p4936.onWallFrames <= this.config.onWallMaxFrames) {
      p4936.velocity.x = p4936.tmpVel.x || p4936.velocity.x;
      p4936.velocity.z = p4936.tmpVel.z || p4936.velocity.z;
    }
    var v4365 = p4936.collidingRamp ? UTILS.GetRampAngle(p4936.collidingRamp) : 0;
    var v4366 = (200 - v4365 * this.config.minRampSlideVelocity * 1.25 * 25 | 0) / 1000;
    if (p4936.collidingRamp && p4936.tmpVel.y < 0 && p4936.onGround && (v4366 * -0.5 / p4936.tmpVel.y <= 0.1 || UTILS.VectorLength({
      x: p4936.tmpVel.x,
      y: 0,
      z: p4936.tmpVel.z
    }) < v4366)) {
      this.RampBounce(p4942, p4936, p4941, v4365);
    } else if (p4941[7] && (!p4936.collidingRamp || p4936.collidingRamp && UTILS.VectorLength({
      x: p4936.tmpVel.x,
      y: 0,
      z: p4936.tmpVel.z
    }) < v4366)) {
      if (p4936.airTime === 0 && p4936.velocity.y === 0 && !p4936.wishJump && !p4936.wishDash) {
        this.AutoBhop(p4942, p4936);
      }
    } else if (p4936.onGround && p4936.collidingRamp && UTILS.VectorLength({
      x: p4936.tmpVel.x,
      y: 0,
      z: p4936.tmpVel.z
    }) >= v4366) {
      if (p4936.wishDash && p4936.walldashTimer <= 0 && p4936.onWall) {
        this.Dash("walldash", p4942, p4936, p4943, p4939, true);
      }
      this.UpdateVelocity(p4936);
    }
    if (p4941[6]) {
      p4936.wishDash = 300;
    }
    if (p4936.wishDash > 0) {
      p4936.wishDash -= p4943;
      if (p4936.wishDash <= 0) {
        p4936.wishDash = 0;
      }
    }
    if (!p4936.dashTimer) {
      p4936.dashTimer = 0;
    }
    if (p4936.dashTimer > 0) {
      p4936.dashTimer -= p4943;
      if (p4936.dashTimer <= 0) {
        p4936.dashTimer = 0;
      }
    }
    if (!p4936.walldashTimer) {
      p4936.walldashTimer = 0;
    }
    if (p4936.walldashTimer > 0) {
      p4936.walldashTimer -= p4943;
      if (p4936.walldashTimer <= 0) {
        p4936.walldashTimer = 0;
      }
    }
    if (p4936.dashTimer <= 0 && p4936.wishDash && p4936.onGround) {
      this.Dash("dash", p4942, p4936, p4943, p4939);
    } else if (p4936.walldashTimer <= 0 && p4936.wishDash && !p4936.onGround && p4936.onWall) {
      this.Dash("walldash", p4942, p4936, p4943, p4939);
    }
    if (p4936.justJumped) {
      return p4936.justJumped = false;
    }
    this.cmd = {
      forwardmove: 0,
      rightmove: 0
    };
    this.SetMovementDir(p4941);
    this.UpdateVelocity(p4936);
    var v4367 = p4939 !== undefined && (this.cmd.rightmove !== 0 || this.cmd.forwardmove !== 0) ? UTILS.TransformDirection({
      y: 0,
      x: this.cmd.rightmove,
      z: this.cmd.forwardmove
    }, UTILS.GetMatrixElements(p4936.xDire)) : {
      x: 0,
      y: 0,
      z: 0
    };
    var v4368 = p4936.onGroundFrames <= 33 ? 0 : 1;
    if (p4936.onGround) {
      this.ApplyFriction(v4368, p4936, p4943);
      if (v4368 === 0) {
        return;
      }
      this.GroundMove(v4367, p4936, p4943);
    } else {
      this.AirMove(v4367, p4936, p4943);
    }
    this.wishJump = false;
    this.UpdateVelocity(p4936);
  },
  Dash: function (p4945, p4946, p4947, p4948, p4949, p4950 = false) {
    var v4369 = false;
    var v4370 = false;
    if (p4945 == "walldash") {
      v4369 = UTILS.VectorReflect({
        x: p4947.tmpVel.x,
        y: 0,
        z: p4947.tmpVel.z
      }, this.config.wallNormal[p4947.onWall - 1], true);
      v4370 = Math.abs(p4947.tmpVel.x) <= 0.0075 && Math.abs(p4947.tmpVel.z) <= 0.0075 && p4949 === undefined;
      p4947.tmpVel.x = v4369.x * (p4950 ? 0.7 : 1);
      p4947.tmpVel.z = v4369.z * (p4950 ? 0.7 : 1);
    }
    p4947.wishDash = 0;
    p4947[p4945 + "Timer"] = this.config[p4945].cooldown;
    var v4371 = p4945 == "dash" ? p4949 !== undefined && (this.cmd.rightmove !== 0 || this.cmd.forwardmove !== 0) ? {
      x: Math.cos(p4949 - p4947.xDire),
      y: 0,
      z: Math.sin(p4949 - p4947.xDire)
    } : {
      x: -Math.sin(p4947.xDire),
      y: 0,
      z: -Math.cos(p4947.xDire)
    } : v4370 ? this.config.wallNormal[p4947.onWall - 1] : {
      x: p4947.tmpVel.x,
      y: 0,
      z: p4947.tmpVel.z
    };
    UTILS.VectorNormalize(v4371);
    var v4372 = Math.max(this.config[p4945].speed + p4948 / (p4945 == "dash" ? 1500 : 25000), UTILS.VectorLength({
      x: p4947.tmpVel.x,
      y: 0,
      z: p4947.tmpVel.z
    }));
    if (p4947.collidingRamp || p4950) {
      this.AutoBhop(p4946, p4947);
    }
    p4947.velocity.x = 0;
    p4947.velocity.y = p4950 ? this.config[p4945].height + Math.abs(p4947.tmpVel[this.config.nDir[p4947.collidingRamp.dir]]) * (UTILS.GetRampAngle(p4947) / 45) * 0.8 : this.config[p4945].height;
    p4947.velocity.z = 0;
    this.UpdateVelocity(p4947);
    this.Accelerate(v4371, v4372, this.config[p4945].acceleration, p4947, p4948);
  },
  UpdateVelocity: function (p4951) {
    p4951.tmpVel.x = p4951.velocity.x;
    p4951.tmpVel.y = p4951.velocity.y;
    p4951.tmpVel.z = p4951.velocity.z;
  },
  SetMovementDir: function (p4952) {
    this.cmd.forwardmove = p4952[4] >= 0 && p4952[4] <= 2 ? -1 : p4952[4] >= 4 && p4952[4] <= 6 ? 1 : 0;
    this.cmd.rightmove = p4952[4] >= 2 && p4952[4] <= 4 ? 1 : p4952[4] >= 6 || p4952[4] === 0 ? -1 : 0;
  },
  ApplyFriction: function (p4953, p4954, p4955) {
    var v4373 = UTILS.VectorLength({
      x: p4954.tmpVel.x,
      y: 0,
      z: p4954.tmpVel.z
    });
    var vLN0690 = 0;
    if (p4954.onGround) {
      var v4374 = v4373 < this.config.groundDeacceleration ? this.config.groundDeacceleration : v4373;
      vLN0690 = v4374 * this.config.friction * p4955 * p4953;
    }
    var v4375 = v4373 - vLN0690;
    if (v4375 < 0) {
      v4375 = 0;
    }
    if (v4373 > 0) {
      v4375 /= v4373;
    }
    p4954.velocity.x *= v4375;
    p4954.velocity.z *= v4375;
  },
  Accelerate: function (p4956, p4957, p4958, p4959, p4960) {
    p4957 *= 1 - p4959.crouchVal / 2;
    var v4376 = UTILS.VectorDot(p4959.tmpVel, p4956);
    var v4377 = p4957 - v4376;
    var v4378 = p4958 * p4960 * p4957;
    if (p4959.isYou) {
      this.SetAccelerationValues(p4959, {
        x: this.cmd.rightmove,
        y: 0,
        z: this.cmd.forwardmove
      }, p4959.tmpVel, p4956, p4957, p4958, p4960);
    }
    if (!(v4377 <= 0)) {
      if (v4378 > v4377) {
        v4378 = v4377;
      }
      p4959.velocity.x += v4378 * p4956.x;
      p4959.velocity.z += v4378 * p4956.z;
    }
  },
  GroundMove: function (p4961, p4962, p4963) {
    UTILS.VectorNormalize(p4961);
    var v4379 = UTILS.VectorLength(p4961);
    v4379 *= this.config.baseSpeed + p4963 / 1000;
    this.Accelerate(p4961, v4379, this.config.groundAcceleration, p4962, p4963);
  },
  AirMove: function (p4964, p4965, p4966) {
    var v4380 = UTILS.VectorLength(p4964);
    v4380 *= this.config.baseSpeed;
    var v4381 = UTILS.VectorDot(p4965.tmpVel, p4964) < 0 ? this.config.airDeacceleration : this.config.airAcceleration;
    if (this.cmd.forwardmove === 0 && this.cmd.rightmove !== 0) {
      if (v4380 > this.config.sideStrafeSpeed) {
        v4380 = this.config.sideStrafeSpeed;
      }
      v4381 = this.config.sideStrafeAcceleration;
    }
    this.Accelerate(p4964, v4380, v4381, p4965, p4966);
  },
  RampBounce: function (p4967, p4968, p4969, p4970) {
    var v4382 = p4968.tmpVel.y * Math.min(1, p4970 / 45) * 0.75;
    if (p4969[7]) {
      this.AutoBhop(p4967, p4968);
    }
    switch (p4968.collidingRamp.dir) {
      case 0:
        p4968.velocity.x += v4382;
        break;
      case Math.PI / 2:
        p4968.velocity.z += v4382;
        break;
      case Math.PI:
        p4968.velocity.x -= v4382;
        break;
      case Math.PI * 1.5:
        p4968.velocity.z -= v4382;
    }
    this.UpdateVelocity(p4968);
  },
  AutoBhop: function (game, p4972) {
    game.players.jump(p4972);
    p4972.wishJump = true;
    p4972.justJumped = true;
  },
  SetAccelerationValues: function (p4973, p4974, p4975, p4976, p4977, p4978, p4979) {
    if (p4973.airTime > 0 && (this.cmd.forwardmove !== 0 || this.cmd.rightmove !== 0)) {
      p4976.y = 0;
      p4974.y = 0;
      p4975.y = 0;
      var v4383 = p4975.y;
      var v4384 = p4976.y;
      var v4385 = UTILS.VectorNorm(p4974);
      var v4386 = UTILS.VectorNorm(p4975);
      var v4387 = UTILS.VectorNorm(p4976);
      var v4388 = Math.acos(UTILS.VectorDot(p4974, p4976) / (v4385 * v4387)) * UTILS.VectorAngleSign(p4976, p4974);
      var v4389 = UTILS.VectorAngleSign(p4976, p4975);
      var v4390 = Math.PI * 2;
      this.angle_optimal = (p4977 * (1 - p4978 * p4979) - v4383 * v4384) / (v4386 * v4387);
      this.angle_optimal = Math.acos(this.angle_optimal);
      this.angle_optimal = v4389 * this.angle_optimal - v4388;
      this.angle_minimum = (p4977 - v4383 * v4384) / (2 - v4387 * v4387) * v4387 / v4386;
      this.angle_minimum = Math.acos(this.angle_minimum < 1 ? this.angle_minimum : 1);
      this.angle_minimum = v4389 * this.angle_minimum - v4388;
      this.angle_maximum = p4978 * -0.5 * p4979 * p4977 * v4387 / v4386;
      this.angle_maximum = Math.acos(this.angle_maximum);
      this.angle_maximum = v4389 * this.angle_maximum - v4388;
      this.angle_current = UTILS.VectorDot(p4975, p4974) / (v4386 * v4385);
      this.angle_current = Math.acos(this.angle_current);
      this.angle_current = UTILS.VectorAngleSign(p4974, p4975) * this.angle_current;
      this.angle_current += Math.trunc((this.angle_minimum - this.angle_current) / v4390) * v4390;
      this.angle_current += Math.trunc((this.angle_maximum - this.angle_current) / v4390) * v4390;
      p4973.overlayInfo = {
        c: this.angle_current,
        o: this.angle_optimal,
        mi: this.angle_minimum,
        ma: this.angle_maximum
      };
    } else {
      p4973.overlayInfo = null;
    }
  }
}, {
  name: "Vehicle",
  prefix: "vh",
  sendVals: ["forwardV", "reverseV", "angVel"],
  vals: [{
    name: "Drag",
    varN: "dr",
    max: 0.999,
    min: 0.001,
    step: 0.001,
    decs: 3,
    cat: 1,
    def: 0.97
  }, {
    name: "Angular Drag",
    varN: "aDr",
    max: 0.999,
    min: 0.001,
    step: 0.001,
    decs: 3,
    cat: 1,
    def: 0.94
  }, {
    name: "Turn Lean",
    varN: "tL",
    max: 100,
    min: -100,
    step: 0.1,
    decs: 1,
    cat: 1,
    def: -2.7
  }, {
    name: "Turn Threshold",
    varN: "trsh",
    max: 0.01,
    min: 0,
    step: 0.0001,
    decs: 4,
    cat: 1,
    def: 0.0025
  }, {
    name: "Turn Conv",
    varN: "trsv",
    max: 1,
    min: 0,
    step: 0.01,
    decs: 2,
    cat: 1,
    def: 0
  }, {
    name: "Max Power",
    varN: "mP",
    max: 1,
    min: 0,
    step: 0.001,
    decs: 3,
    cat: 1,
    def: 0.12
  }, {
    name: "Power Force",
    varN: "pF",
    max: 0.1,
    min: 0,
    step: 0.0001,
    decs: 4,
    cat: 1,
    def: 0.0012
  }, {
    name: "Max Reverse",
    varN: "mR",
    max: 1,
    min: 0,
    step: 0.0001,
    decs: 4,
    cat: 1,
    def: 0.0375
  }, {
    name: "Reverse Force",
    varN: "rF",
    max: 0.1,
    min: 0,
    step: 0.0001,
    decs: 4,
    cat: 1,
    def: 0.0005
  }],
  dir: function (p4980, p4981, p4982, p4983, p4984, p4985, p4986) {
    if (!p4980.onGround) {
      return;
    }
    var v4391 = p4980.config;
    var v4392 = p4984 / (1000 / 60);
    var v4393 = p4986[4] == 0 || p4986[4] == 1 || p4986[4] == 2;
    var v4394 = p4986[4] == 4 || p4986[4] == 5 || p4986[4] == 6;
    if (v4393) {
      p4980.forwardV += v4391.vhpF * v4392;
    } else {
      p4980.forwardV -= v4391.vhpF * v4392;
    }
    if (v4394) {
      p4980.reverseV += v4391.vhrF * v4392;
    } else {
      p4980.reverseV -= v4391.vhrF * v4392;
    }
    p4980.forwardV = Math.max(0, Math.min(v4391.vhmP, p4980.forwardV));
    p4980.reverseV = Math.max(0, Math.min(v4391.vhmR, p4980.reverseV));
    var v4395 = p4980.config.trnSp || 1;
    if (p4980.config.vhtrsv) {
      v4395 *= p4980.config.vhtrsv * 10 * (p4980.forwardV + p4980.reverseV);
    }
    v4395 *= p4980.config.trnSpd || 1;
    v4395 *= 0.004;
    const v4396 = p4980.forwardV >= p4980.config.vhtrsh || v4394;
    const v4397 = v4394 ? -1 : 1;
    if (v4396) {
      if (p4986[4] == 2 || p4986[4] == 3 || p4986[4] == 4) {
        p4980.angVel -= v4397 * v4392 * v4395;
      }
      if (p4986[4] == 0 || p4986[4] == 6 || p4986[4] == 7) {
        p4980.angVel += v4397 * v4392 * v4395;
      }
    }
  },
  mov: function (p4987, p4988, p4989, p4990, p4991, p4992, p4993, p4994) {
    var v4398 = p4987.config;
    var v4399 = p4994 / (1000 / 60);
    if (p4987.meshRef) {
      var v4400 = p4987.config.mdlDr % 180 != 0;
      if (v4400) {
        p4987.meshRef.eulerOrder = "YXZ";
        p4987.meshRef.rotation.x = p4987.angVel * v4398.vhtL;
      } else {
        p4987.meshRef.eulerOrder = "ZYX";
        p4987.meshRef.rotation.z = p4987.angVel * v4398.vhtL;
      }
    }
    var v4401 = p4988 * 120;
    p4987.velocity.x -= Math.sin(p4987.xDire) * (v4401 * (p4987.forwardV - p4987.reverseV));
    p4987.velocity.z -= Math.cos(p4987.xDire) * (v4401 * (p4987.forwardV - p4987.reverseV));
    var v4402 = p4987.velocity.x * Math.pow(v4398.vhdr, v4399);
    p4987.x += (v4402 - p4987.velocity.x) / Math.log(v4398.vhdr) * p4987.config.speedX;
    p4987.velocity.x = v4402;
    var v4403 = p4987.velocity.z * Math.pow(v4398.vhdr, v4399);
    p4987.z += (v4403 - p4987.velocity.z) / Math.log(v4398.vhdr) * p4987.config.speedZ;
    p4987.velocity.z = v4403;
    var v4404 = p4987.angVel * Math.pow(v4398.vhaDr, v4399);
    p4987.xDire += (v4404 - p4987.angVel) / Math.log(v4398.vhaDr);
    p4987.xDire %= Math.PI * 2;
    p4987.angVel = v4404;
  },
  vel: function (p4995, p4996, p4997) {
    if (p4995.velocity.y) {
      var vLN099932 = 0.9993;
      var v4405 = p4995.velocity.y * Math.pow(vLN099932, p4997);
      p4995.y += (v4405 - p4995.velocity.y) / Math.log(vLN099932) * p4995.config.speedY;
      p4995.velocity.y = v4405;
    }
  }
}, {
  name: "MMORPG",
  dir: function (p4998, p4999, p5000, p5001, p5002) {
    if (p5001 != null) {
      var v4406 = Math.PI * 2;
      var v4407 = p4999 - p5001 - Math.PI / 2;
      var v4408 = (p4998.xDire - v4407 + v4406) % v4406;
      var v4409 = Math.min(Math.abs(v4408 - v4406), v4408, p5002 * 0.012);
      var v4410 = v4408 - Math.PI >= 0 ? 1 : -1;
      p4998.xDire += v4410 * v4409 + v4406;
      p4998.xDire %= v4406;
    }
  },
  mov: function (p5003, p5004, p5005, p5006, p5007) {
    var v4411 = (p5007 - p5006 - Math.PI / 2) % (Math.PI * 2);
    v4411 = -v4411 - Math.PI / 2;
    if (p5006 !== undefined) {
      p5003.velocity.x += p5004 * Math.cos(v4411);
      p5003.velocity.z += p5004 * Math.sin(v4411);
    }
  }
}];